import { createSlice } from "@reduxjs/toolkit";
import { getMetricsQueue, getMyMetricsData } from "../services/metrics";

interface MetricsState {
  status: string;
  showLoadingIndicator: boolean;
  queueMetrics: unknown[];
  myMetricsData: unknown[];
}

const initialState: MetricsState = {
  status: "idle",
  showLoadingIndicator: false,
  queueMetrics: [],
  myMetricsData: [],
};

/** Extract row array from API response; supports payload.data, payload.data.data, payload.data.metrics, etc. */
function toMetricsArray(payload: unknown): unknown[] {
  const body = (payload as { data?: unknown })?.data;
  if (Array.isArray(body)) return body;
  const inner = body as Record<string, unknown> | undefined;
  if (inner && Array.isArray(inner.metrics)) return inner.metrics as unknown[];
  if (inner && Array.isArray(inner.data)) return inner.data as unknown[];
  return [];
}

const metricsSlice = createSlice({
  name: "queueMetrics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMetricsQueue.pending, (state) => {
        state.status = "pending";
        state.showLoadingIndicator =
          state.queueMetrics.length > 0 ? false : true;
      })
      .addCase(getMetricsQueue.fulfilled, (state, action) => {
        state.status = "success";
        state.queueMetrics = toMetricsArray(action.payload);
        state.showLoadingIndicator = false;
      })
      .addCase(getMetricsQueue.rejected, (state) => {
        state.status = "rejected";
        state.showLoadingIndicator = false;
        state.queueMetrics = [];
      })
      .addCase(getMyMetricsData.pending, (state) => {
        state.status = "pending";
        state.showLoadingIndicator =
          state.myMetricsData.length > 0 ? false : true;
      })
      .addCase(getMyMetricsData.fulfilled, (state, action) => {
        state.status = "success";
        state.myMetricsData = toMetricsArray(action.payload);
        state.showLoadingIndicator = false;
      })
      .addCase(getMyMetricsData.rejected, (state) => {
        state.status = "rejected";
        state.showLoadingIndicator = false;
        state.myMetricsData = [];
      });
  },
});

export default metricsSlice.reducer;
